import { Alert, Button, Snackbar } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerSW } from 'virtual:pwa-register';

type UpdateServiceWorker = ReturnType<typeof registerSW>;

export const PwaUpdatePrompt = () => {
  const { t } = useTranslation();
  const updateServiceWorker = useRef<UpdateServiceWorker>();
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    updateServiceWorker.current = registerSW({
      immediate: true,
      onNeedRefresh: () => setUpdateAvailable(true),
    });

    return () => {
      updateServiceWorker.current = undefined;
    };
  }, []);

  return (
    <Snackbar open={updateAvailable} autoHideDuration={null} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={() => void updateServiceWorker.current?.(true)}>
            {t('pwa.update.action')}
          </Button>
        }
      >
        {t('pwa.update.available')}
      </Alert>
    </Snackbar>
  );
};
